module.exports = {"id":"198240","name":"Raul García","rating":"74","photo":"./data/images/photos/3/198240.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["DG","DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RaulGarcia0.json
// module id = 3550
// module chunks = 0